import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, X } from 'lucide-react';
import { ThemeContext } from '../context/ThemeContext';
import { dismissReviewPopup, remindMeLater } from '../services/reviews';

const ReviewInvitationPopup = ({ onClose }) => {
  const { darkMode } = useContext(ThemeContext);
  const navigate = useNavigate();

  const handleLeaveReview = () => {
    navigate('/account/review');
    onClose();
  };

  const handleRemindLater = async () => {
    try {
      await remindMeLater();
      onClose();
    } catch (err) {
      console.error('Error setting reminder:', err);
      onClose();
    }
  };

  const handleDismiss = async () => {
    try {
      await dismissReviewPopup();
      onClose();
    } catch (err) {
      console.error('Error dismissing popup:', err);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className={`relative max-w-md w-full rounded-lg shadow-xl p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Close button */}
        <button
          onClick={handleDismiss}
          className={`absolute top-4 right-4 p-1 rounded-full transition-colors ${
            darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-600'
          }`}
        >
          <X size={20} />
        </button>

        {/* Star icon */}
        <div className="flex justify-center mb-4">
          <div className="flex space-x-1">
            {[...Array(5)].map((_, index) => (
              <Star
                key={index}
                size={24}
                className="fill-yellow-400 text-yellow-400"
              />
            ))}
          </div>
        </div>

        {/* Title */}
        <h2 className={`text-2xl font-bold text-center mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
          Enjoying Torque?
        </h2>

        {/* Message */}
        <p className={`text-center mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          We'd love to hear about your experience! Your feedback helps us improve and helps other businesses make informed decisions.
        </p>

        {/* Action buttons */}
        <div className="space-y-3">
          <button
            onClick={handleLeaveReview}
            className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Leave a Review
          </button>

          <button
            onClick={handleRemindLater}
            className={`w-full px-6 py-3 rounded-lg font-medium transition-colors ${
              darkMode
                ? 'bg-gray-700 text-white hover:bg-gray-600'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Remind Me in 30 Days
          </button>

          <button
            onClick={handleDismiss}
            className={`w-full text-sm ${darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-600 hover:text-gray-700'}`}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewInvitationPopup;
